import { render, staticRenderFns } from "./SmsReceived.vue?vue&type=template&id=5a700e86&"
import script from "./SmsReceived.vue?vue&type=script&lang=js&"
export * from "./SmsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SmsReceived.vue"
export default component.exports